<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <input id="search" v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                </div>
            </div>
            <div class="col-md-6" />
            <div class="col-md-2">
                <b-button id="create" v-b-modal.form-modal variant="primary" class="btn-block" @click="cleanUpForm()"
                    v-if="userData.role == 'admin'">
                    Create
                </b-button>
            </div>
        </div>

        <b-card-code no-body>
            <div class="table-responsive-sm">
                <table class="table b-table table-fixed">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Location</th>
                            <th>Position</th>
                            <th>Partner</th>
                            <th>Is Active</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoading">
                            <td colspan="5" class="text-center">
                                <b-spinner label="Loading..." variant="primary" />
                            </td>
                        </tr>
                        <template v-if="!isLoading">
                            <tr v-for="item, index in result.items" :key="index">
                                <td>{{ item.title || '-' }}</td>
                                <td>{{ item.location || '-' }}</td>
                                <td>{{ item.position || '-' }}</td>
                                <td>{{ item.partner && item.partner.name || '-' }}</td>
                                <td>
                                    <div
                                        :class="item.is_active ? 'bg-success' : 'bg-danger'"
                                        style="width: 8px; height: 8px; border-radius: 50%"
                                    ></div>
                                </td>
                                <td class="text-right">
                                    <div class="btn-group" role="group" aria-label="Basic example"
                                        v-if="userData.role == 'admin'">

                                        <b-button id="edit" variant="info" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Edit"
                                            @click="editItem(item)">
                                            <feather-icon icon="EditIcon" />
                                        </b-button>

                                        <b-button id="delete" variant="danger" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Delete"
                                            @click="deleteItem(item._id)">
                                            <feather-icon icon="Trash2Icon" />
                                        </b-button>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="totalItems == 0">
                                <td colspan="5" class="text-center">
                                    Data is empty.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="row mt-1 mx-0">
                    <div class="col-6 pl-2">
                        <small>Showing {{ Math.min(perPage * currentPage, totalItems) }} to {{ totalItems || 0 }} from
                            {{ totalRows || 0
                            }}
                        </small>
                    </div>
                    <div class="col-6 pr-2">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"
                            size="sm" class="my-0" />
                    </div>
                </div>
            </div>
        </b-card-code>

        <!-- Add/Edit Modal -->
        <b-modal id="form-modal" size="lg" :title="editId != null ? 'Edit Category Mapping' : 'Add Category Mapping'" no-close-on-backdrop>

            <div>
                <b-form-group v-if="userData.role == 'admin'">
                    <label for="partner">Partner: <span class="text-danger">*</span></label>
                    <v-select id="partner" v-model="formPayload.partner" :options="options.partner"
                        :reduce="item => item.uuid" label="name" placeholder="Type to search Partner..."
                        @search="onSearchPartner">
                        <template slot="no-options">
                            Type here to search partner...
                        </template>
                    </v-select>
                </b-form-group>
    
                <FormInput :id="'title'" :label="'Title'"
                    v-model="formPayload.title"
                    :validation="validations.title" :placeholder="'Title'" :required="true"
                    :type="'text'" :modelValue="formPayload.title" />
                
                <FormInput :id="'embed_url'" :label="'Embed URL'"
                    v-model="formPayload.embed_url"
                    :validation="validations.embed_url" :placeholder="'Embed URL'" :required="true"
                    :type="'text'" :modelValue="formPayload.embed_url" />

                <FormSelect id="position" label="Position" v-model="formPayload.position"
                    :modelValue="formPayload.position" :options="options.positions" :validation="validations.position" />
    
                <b-form-group>
                    <div class="d-flex">
                        <label for="is_active" class="mr-1">Is Active: <span class="text-danger">*</span></label>
                        <b-form-checkbox id="is_active" v-model="formPayload.is_active" />
                    </div>
                </b-form-group>
            </div>

            <template #modal-footer="{}">
                <div v-if="isLoading" class="mb-1">
                    <b-spinner class="mb-2" variant="primary" /><br>
                </div>
                <b-button v-if="editId == null" variant="success" :disabled="isLoading" @click="createItem()">
                    Save Item
                </b-button>
                <b-button v-else variant="success" :disabled="isLoading" @click="updateItem()">
                    Save Item
                </b-button>
            </template>
        </b-modal>
        <!-- Add/Edit Modal -->
    </div>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BCard, BCardText, BButton, BSpinner, BPagination, BFormInput, BFormGroup, BFormFile, BRow, BCol, BForm, BFormTextarea, BImg, BFormSelect, BFormCheckbox,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'

import { successNotification, errorNotification } from '@/auth/utils'
import FormInput from '@/components/FormInput.vue'
import FormSelect from '@/components/FormSelect.vue'

import vSelect from 'vue-select'
import qs from 'qs'
export default {
    title() {
        return 'Embed Media'
    },
    components: {
        BCard,
        BButton,
        BCardText,
        BCardCode,
        BSpinner,
        BPagination,
        BFormInput,
        FormInput,
        BFormGroup,
        BFormFile,
        BRow,
        BCol,
        BForm,
        BFormTextarea,
        BImg,
        BFormSelect,
        BFormCheckbox,
        vSelect,
        FormSelect
    },
    directives: {
        Ripple,
    },
    setup() {
        return { successNotification, errorNotification }
    },
    mixins: [heightTransition],
    watch: {
        filter: {
            handler: _.debounce(function () {
                this.getData()
            }, 300),
            deep: true,
        },
        currentPage: {
            handler: _.debounce(function (value) {
                this.getData(value);
            }, 300),
            deep: true,
        },
    },
    data() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return {
            userData,
            // Pagination
            currentPage: 1,
            totalRows: 0,
            perPage: 10,
            itemCount: 0,
            totalItems: 0,
            pageOptions: [3, 5, 10],

            options: {
                category: [],
                partner: [],
                positions: [
                    { value: null, text: 'Please select an option' },
                    { value: 'navbar', text: 'Navbar' },
                    // { value: 'left-sidebar', text: 'Left Sidebar' },
                    { value: 'right-sidebar', text: 'Right Sidebar' },
                ]
            },

            result: Object,
            isLoading: false,
            formPayload: {
                is_active: false,
                title: null,
                location: 'homepage',
                partner: userData?.partner?._id || null,
                position: null,
                embed_url: null,
                type: 'radio'
            },
            editId: null,
            filter: {
                search: '',
            },
            validations: {},
        }
    },
    mounted() {
        this.getData()
        this.getPartner()
    },
    created() {
    },
    destroyed() {
    },
    methods: {
        // Partner
        onSearchPartner(search, loading) {
            if (search.length) {
                loading(true)
                this.searchPartner(loading, search, this)
            }
        },
        searchPartner: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/partners?&search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.partner = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getPartner() {
            if (this.userData.role == 'admin') {
                this.$http.get('/admin/partners', {
                }).then((result) => {
                    this.options.partner = result.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                }).catch((err) => {

                });
            }
        },
        cleanUpForm() {
            this.editId = null
            this.formPayload = {
                is_active: false,
                title: null,
                location: 'homepage',
                partner: this.userData?.partner?._id || null,
                position: null,
                embed_url: null,
                type: 'radio'
            }
        },
        getData(page = 1) {
            this.isLoading = true
            this.currentPage = page
            const queryParams = this.filter
            queryParams.page = this.currentPage

            this.$http.get('/admin/media-embeds', {
                params: queryParams,
            })
                .then(response => {
                    const data = response.data.data;
                    this.result = data;
                    this.itemCount = data.meta.item_count;
                    this.totalItems = data.meta.total_items;
                    this.currentPage = data.meta.current_page;
                    this.totalRows = data.meta.total_items;
                    this.isLoading = false;
                }).catch((error) => {
                    this.isLoading = false;
                })
        },
        createItem() {
            const form = this.preparePayloadQs()

            this.$http.post('/admin/media-embeds', form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Embed successfully created')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        updateItem() {
            const form = this.preparePayloadQs()

            this.$http.patch(`/admin/media-embeds/${this.editId}`, form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Embed successfully updated!')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        preparePayloadQs() {
            const cleanPayload = {};

            for (const key in this.formPayload) {
                const value = this.formPayload[key];
                
                // Skip empty/null
                if (!this.formPayload.hasOwnProperty(key) || value === null || value === '') continue;

                // 1. SPECIAL HANDLING FOR PARTNER (Object -> ID)
                if (key === 'partner') {
                    cleanPayload[key] = typeof value === 'object' ? value?._id : value;
                } 
                // 3. EVERYTHING ELSE
                else {
                    cleanPayload[key] = value;
                }
            }

            // 3. Stringify using QS
            // 'brackets' ensures output is categories[]=123&categories[]=456
            return qs.stringify(cleanPayload, { arrayFormat: 'brackets' });
        },
        preparePayload() {
            const form = new FormData()

            // eslint-disable-next-line no-restricted-syntax
            for (const key in this.formPayload) {
                if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] != null && this.formPayload[key] != '') {
                    // Handle if this.formPayload[key] is array
                    form.append(key, this.formPayload[key])
                }
            }

            return form
        },
        editItem(item) {
            this.editId = item._id
            this.$http.get(`admin/media-embeds/${this.editId}`).then((result) => {
                const data = result.data.data
                this.formPayload = {
                    is_active: data.is_active,
                    title: data.title,
                    location: data.location,
                    partner: data.partner,
                    position: data.position.toString(),
                    embed_url: data.embed_url
                }

                this.$bvModal.show('form-modal')
            }).catch((err) => {
                console.log(err);
            });
        },
        deleteItem(id) {
            this.$swal({
                title: 'Are you sure?',
                text: 'Are you sure to delete this embed?',
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$http.delete(`admin/media-embeds/${id}`)
                        .then(response => {
                            this.getData(this.currentPage)
                            this.$swal({
                                icon: 'success',
                                title: 'Success!',
                                text: 'Embed successfully deleted',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                            })
                        })
                        .catch(error => {
                            const validations = error.response.data.meta.validations
                            const messages = error.response.data.meta.messages
                            // this.validations = validations
                            if (validations) {
                                for (const key in validations) {
                                    if (validations.hasOwnProperty(key)) {
                                        errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                                    }
                                }
                            }
                            if (messages) {
                                errorNotification(this, 'Oops!', messages)
                            }
                        })
                }
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.repeater-form {
    overflow: hidden;
    transition: .35s height;
}
</style>
